/* Product page behaviour (moved out of sections/product.liquid so it is cached). */
document.addEventListener('DOMContentLoaded', function() {
  const scrollContainer = document.querySelector('[id^="HorizontalWheelScroll-"]');
  
  // --- 1. DESKTOP: MAP VERTICAL SCROLL TO HORIZONTAL CAROUSEL ---
  if (scrollContainer) {
    let isDesktop = window.innerWidth >= 768;
    
    window.addEventListener('resize', function() {
      isDesktop = window.innerWidth >= 768;
    }, { passive: true });

    scrollContainer.addEventListener('wheel', function(evt) {
      if (isDesktop && Math.abs(evt.deltaY) > 0) {
        // Calculate if we have room to scroll
        const canScrollRight = Math.ceil(scrollContainer.scrollLeft + scrollContainer.clientWidth) < scrollContainer.scrollWidth;
        const canScrollLeft = scrollContainer.scrollLeft > 0;
        
        // If scrolling down/up and there is room, translate to right/left
        if ((evt.deltaY > 0 && canScrollRight) || (evt.deltaY < 0 && canScrollLeft)) {
          evt.preventDefault(); // Stop default vertical scroll behavior
          scrollContainer.scrollLeft += evt.deltaY; // Move horizontally instead
        }
      }
    }, { passive: false });
  }

  // --- 2. TABLET: DRAWER TOGGLE & AUTO-OPEN LOGIC ---
  const toggleBtn = document.querySelector('.tablet-details-toggle');
  const detailsDrawer = document.querySelector('.product__details__wrapper.custom-width');
  
  if (toggleBtn && detailsDrawer) {
    // Manual click toggle
    toggleBtn.addEventListener('click', function() {
      detailsDrawer.classList.toggle('is-open');
    });

    // Auto-open when scrolled to the right end
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', function() {
        // Only run on tablet screens
        if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
          // Check if scrolled to the end (with a 5px buffer for high-res screens)
          const isAtRightEnd = Math.ceil(scrollContainer.scrollLeft + scrollContainer.clientWidth) >= (scrollContainer.scrollWidth - 5);
          
          if (isAtRightEnd) {
            detailsDrawer.classList.add('is-open');
          }
        }
      }, { passive: true });
    }
  }

 // --- 3. MOBILE: AUTO-SCROLL TO #as-seen-on AT 90% OF LAST IMAGE ---
  let isAutoScrolling = false;
  let lastScrollLeft = 0;

  // Custom function for luxury smooth scrolling
  function luxurySmoothScroll(targetElement, duration = 1500) {
    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    let startTime = null;

    // "Ease Out Quart" - The gold standard for premium UI scrolling.
    // Starts with momentum, then gracefully and slowly glides to a stop.
    function easeOutQuart(t) {
      return 1 - Math.pow(1 - t, 4);
    }

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      
      // Calculate progress from 0.0 to 1.0
      let progress = timeElapsed / duration;
      if (progress > 1) progress = 1; 

      // Apply the luxury curve to the progress
      const easeProgress = easeOutQuart(progress);

      window.scrollTo(0, startPosition + (distance * easeProgress));
      
      if (progress < 1) {
        requestAnimationFrame(animation);
      }
    }
    
    requestAnimationFrame(animation);
  }

  if (scrollContainer) {
    scrollContainer.addEventListener('scroll', function(e) {
      if (window.innerWidth >= 768) return; 
      
      const currentScrollLeft = scrollContainer.scrollLeft;
      const isScrollingRight = currentScrollLeft > lastScrollLeft;
      lastScrollLeft = currentScrollLeft;

      if (!isScrollingRight || isAutoScrolling) return;

      const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      const slides = scrollContainer.querySelectorAll('.product__photo--custom');
      
      if (!slides.length) return;
      
      const lastSlide = slides[slides.length - 1];
      const threshold = maxScroll - (lastSlide.offsetWidth * 0.1);

      if (currentScrollLeft >= threshold) {
        const targetSection = document.getElementById('as-seen-on');
        if (targetSection) {
          isAutoScrolling = true;
          
          // 1. Delay slightly so it doesn't interrupt the user's swipe instantly
          setTimeout(() => {
            
            // 2. Trigger the luxury scroll (I increased it to 1500ms for a slower glide)
            luxurySmoothScroll(targetSection, 500);

            // 3. Reset lock after animation completes
            setTimeout(() => {
              isAutoScrolling = false;
            }, 600);

          }, 50);
        }
      }
    }, { passive: true });
  }

});

document.addEventListener('DOMContentLoaded', function() {
  const productId = window.AsrjProductId;
  const desiredLimit = 8; 
  const fetchLimit = 20; // Increased buffer to ensure we have 8 left after filtering

  // Add the exact tags of the products you want to hide (lowercase)
  const blockedTags = [
    'do-not-recommend'
  ];

  // Helper function to safely handle image URLs
  const cleanUrl = (url) => url ? url.replace(/([?&])(width|height)=\d+/g, '') : '';
  
  // First image selector logic
  const getFirstImgUrl = (item) => {
    if (item.images && item.images.length > 0) {
      return item.images[0];
    }
    return item.featured_image || '';
  };

  fetch(`/recommendations/products.json?product_id=${productId}&limit=${fetchLimit}&intent=related`)
    .then(response => response.json())
    .then(data => {
      if (!data.products || data.products.length === 0) {
        return fetch(`/collections/new-in/products.json?limit=${fetchLimit}`)
          .then(response => response.json())
          .then(newInData => newInData.products);
      } else {
        return data.products;
      }
    })
    .then(products => {
      if (!products || products.length === 0) return;

      // --- THE TAG FILTER ---
      let finalProducts = products.filter(item => {
        // Check if the item is the current product being viewed
        if (item.id === productId) return false;

        // Check if the item has any tags that match our blockedTags list
        if (item.tags && Array.isArray(item.tags)) {
          const hasBlockedTag = item.tags.some(tag => blockedTags.includes(tag.toLowerCase()));
          if (hasBlockedTag) return false; // Drop it if it has a blocked tag
        }

        return true; // Keep it if it passes the checks
      });

      // --- THE CUTOFF ---
      finalProducts = finalProducts.slice(0, desiredLimit);

      if (finalProducts.length === 0) return;

      const recommendationsContainer = document.querySelector('.related-products-grid');
      if (!recommendationsContainer) return;

      // Assign the new Flex classes to the container
      recommendationsContainer.className = 'custom-cross-sell-products related-products-grid';
      recommendationsContainer.style.cssText = 'margin-bottom: 40px;'; // Removed inline border logic

      let productHTML = '';

      // Loop through products individually to output the requested grid HTML
      finalProducts.forEach((item) => {
        const imgUrl = getFirstImgUrl(item);
        if (!imgUrl) return;

        const productUrl = item.url ? item.url : `/products/${item.handle}`;
        const fallbackSrc = `${cleanUrl(imgUrl)}${cleanUrl(imgUrl).includes('?') ? '&' : '?'}width=800`;
        
        // Formatting Prices
        const storeCurrency = (window.Shopify && window.Shopify.currency) ? window.Shopify.currency.active : "EUR";
        
        // 1. Create a native formatter for the store's current currency
        const formatter = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: storeCurrency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        });

        // 2. Format the prices (Shopify returns cents, so divide by 100)
        let priceStr = item.price ? formatter.format(item.price / 100) : "";
        let comparePriceStr = item.compare_at_price ? formatter.format(item.compare_at_price / 100) : "";

        // 3. Specific override: If it's Euros, swap the symbol out for the text "EUR " at the front
        if (storeCurrency === 'EUR') {
          priceStr = 'EUR ' + priceStr.replace('€', '').trim();
          comparePriceStr = 'EUR ' + comparePriceStr.replace('€', '').trim();
        }
        
        const isSale = item.compare_at_price > item.price;
        
        const hasVariants = item.variants && item.variants.length > 1;
        const soldOut = !item.available;
        const firstVariantId = item.variants && item.variants.length > 0 ? item.variants[0].id : '';

        // Add to cart button logic
        let buttonHtml = '';
        if (hasVariants) {
          buttonHtml = `
            <button type="button" class="add-to-cart-button product-grid-item-add-to-cart-button js-quick-add-btn" 
                    data-product-handle="${item.handle}" 
                    data-product-id="${item.id}" 
                    ${soldOut ? 'disabled' : ''} 
                    style="padding: 0 0 0 10px; font-size:12px; background: none; border: none; ${soldOut ? 'cursor: not-allowed; opacity: 0.2;' : 'cursor: pointer;'}">
              +
            </button>
          `;
        } else {
          buttonHtml = `
            <form class="product-form custom-cross-sell-add-to-cart" action="/cart/add" method="post" style="margin: 0; display: inline-flex;">
              <input type="hidden" name="id" value="${firstVariantId}">
              <button type="submit" class="add-to-cart-button product-grid-item-add-to-cart-button" 
                      ${soldOut ? 'disabled' : ''} 
                      style="padding: 0 0 0 10px; font-size:12px; background: none; border: none; ${soldOut ? 'cursor: not-allowed; opacity: 0.2;' : 'cursor: pointer;'}" 
                      onclick="event.stopPropagation();">
                +
              </button>
            </form>
          `;
        }

        let priceHtml = isSale 
          ? `<span style="text-decoration: line-through; margin-right: 4px;">${comparePriceStr}</span><span class="sale-price">${priceStr}</span>`
          : `${priceStr}`;

        // Build the HTML matching your required snippet
        productHTML += `
          <a class="custom-cross-sell-product" href="${productUrl}">
            <div class="custom-cross-sell-image" style="position: relative; width: 100%; padding-top: 135%; overflow: hidden;">
              <img src="${fallbackSrc}" alt="${item.title}" class="product-image-custom-cross-sell product-image-custom-cross-sell-hover" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; display: block;">
            </div>
            
            <div class="custom-cross-sell-info">
              <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 4px;">
                <p class="product__grid__title" style="margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1; font-size: 13px;">
                  ${item.title}
                </p>
                ${buttonHtml}
              </div>
              <p class="product__grid__title" style="margin-top: 2px; font-size: 13px;">
                ${priceHtml}
              </p>
            </div>
          </a>
        `;
      });

      recommendationsContainer.innerHTML = productHTML;
    })
    .catch(error => console.error('Related products error:', error));
});

document.addEventListener('DOMContentLoaded', function() {
  const tabsWrapper = document.querySelector('.tabs-wrapper');
  const customAccordion = document.querySelector('.custom-payment-accordion');
  
  if (!tabsWrapper || !customAccordion) return;

  function evaluateAccordions() {
    // Looks for every common "open" state used by premium themes (like Pipeline)
    const hasOpenAccordion = tabsWrapper.querySelector('.is-active, .active, .is-open, .open, [aria-expanded="true"], details[open]');
    
    if (hasOpenAccordion) {
      customAccordion.classList.add('is-hidden');
    } else {
      customAccordion.classList.remove('is-hidden');
    }
  }

  // 1. Aggressive Click Listener (Uses Capture Phase to bypass theme blocking)
  document.addEventListener('click', function(event) {
    // Only fire if the click happened inside the tabs wrapper
    if (tabsWrapper.contains(event.target)) {
      // Check immediately, then check again after the theme's animation finishes
      setTimeout(evaluateAccordions, 10);
      setTimeout(evaluateAccordions, 250);
      setTimeout(evaluateAccordions, 500);
    }
  }, true); // "true" intercepts the click before the theme can stop it

  // 2. MutationObserver as a fallback for automated toggles
  const observer = new MutationObserver(evaluateAccordions);
  observer.observe(tabsWrapper, {
    attributes: true, 
    subtree: true, 
    attributeFilter: ['class', 'aria-expanded', 'open']
  });

  // 3. Set the initial state on page load
  setTimeout(evaluateAccordions, 100);
});

// Product accordions: shorter open/close, then scroll the opened panel clear of the
// viewport edge and the fixed mobile add-to-cart bar. Theme slide duration is 500ms
// (theme.js); we retarget it before paint. Scroll runs when the height transition ends.
(function () {
  var OPEN_MS = 280;
  var GAP = 12;
  var revealToken = 0;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function accordionRevealDelta(panelTop, panelBottom, viewTop, viewBottom) {
    var viewHeight = viewBottom - viewTop;
    if (viewHeight < 40) return 0;
    if (panelTop >= viewTop && panelBottom <= viewBottom) return 0;

    var panelHeight = panelBottom - panelTop;
    var delta = 0;
    if (panelHeight <= viewHeight) {
      if (panelBottom > viewBottom) delta = panelBottom - viewBottom;
      if (panelTop - delta < viewTop) delta = panelTop - viewTop;
    } else {
      delta = panelTop - viewTop;
    }
    return Math.abs(delta) < 4 ? 0 : delta;
  }

  function stickyHeaderBottom() {
    var bar = document.querySelector('.header__wrapper.js__header__stuck .theme__header');
    if (!bar) return 0;
    var rect = bar.getBoundingClientRect();
    if (rect.bottom < 8 || rect.height < 1) return 0;
    var style = window.getComputedStyle(bar);
    if (style.display === 'none' || style.visibility === 'hidden') return 0;
    return rect.bottom;
  }

  function fixedBottomInset(viewBottom) {
    var selectors = ['.product__submit', '#Avada-CookiesBar', '.shopify-pc__banner__dialog'];
    var inset = 0;
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        var style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') return;
        if (style.position !== 'fixed' && style.position !== 'sticky') return;
        var rect = el.getBoundingClientRect();
        if (rect.height < 8 || rect.height > window.innerHeight * 0.6) return;
        if (rect.bottom < viewBottom - 8 || rect.top >= viewBottom) return;
        inset = Math.max(inset, viewBottom - rect.top);
      });
    });
    return inset;
  }

  function getScrollParent(el) {
    var parent = el.parentElement;
    while (parent && parent !== document.body && parent !== document.documentElement) {
      var oy = window.getComputedStyle(parent).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && parent.scrollHeight > parent.clientHeight + 2) {
        return parent;
      }
      parent = parent.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  }

  function isDocumentScroller(scroller) {
    return !scroller || scroller === document.scrollingElement || scroller === document.documentElement || scroller === document.body;
  }

  function visibleBounds(scroller) {
    var vv = window.visualViewport;
    var viewTop = vv ? vv.offsetTop : 0;
    var viewBottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
    var top;
    var bottom;
    if (isDocumentScroller(scroller)) {
      top = viewTop + stickyHeaderBottom();
      bottom = viewBottom - fixedBottomInset(viewBottom);
    } else {
      var rect = scroller.getBoundingClientRect();
      top = Math.max(rect.top, viewTop);
      bottom = Math.min(rect.bottom, viewBottom);
    }
    return { top: top + GAP, bottom: bottom - GAP };
  }

  function scrollByDelta(scroller, delta) {
    if (!delta) return;
    // Assign scrollTop so a stylesheet scroll-behavior: smooth cannot queue a
    // new smooth scroll on every animation frame.
    if (isDocumentScroller(scroller)) {
      var root = document.scrollingElement || document.documentElement;
      root.scrollTop += delta;
    } else {
      scroller.scrollTop += delta;
    }
  }

  function revealPanel(trigger, body) {
    if (!trigger.classList.contains('accordion-is-open')) return;
    var scroller = getScrollParent(trigger);
    var bounds = visibleBounds(scroller);
    var titleRect = trigger.getBoundingClientRect();
    var bodyRect = body.getBoundingClientRect();
    var delta = accordionRevealDelta(titleRect.top, Math.max(bodyRect.bottom, titleRect.bottom), bounds.top, bounds.bottom);
    scrollByDelta(scroller, delta);
  }

  function retargetDuration(group, duration) {
    group.querySelectorAll('[data-accordion-body]').forEach(function (body) {
      if (body.style.transitionDuration) {
        body.style.transitionDuration = duration + 'ms';
      }
    });
  }

  // Chase the open for the theme's original 500ms as well as our 280ms, so a
  // missed duration retarget still finishes with the panel in view.
  var CHASE_MS = 540;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.product-accordion .accordion__title');
    if (!trigger) return;
    var group = trigger.closest('.product-accordion');
    if (!group) return;

    var opening = !trigger.classList.contains('accordion-is-open');
    var duration = prefersReducedMotion() ? 0 : OPEN_MS;
    var token = ++revealToken;

    queueMicrotask(function () {
      retargetDuration(group, duration);
    });

    if (!opening) return;

    var bodyId = trigger.getAttribute('aria-controls');
    var body = bodyId ? document.getElementById(bodyId) : null;
    if (!body) return;

    if (duration === 0) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (token !== revealToken) return;
          revealPanel(trigger, body);
        });
      });
      return;
    }

    chaseOpen(trigger, body, group, token);
  }, true);

  function chaseOpen(trigger, body, group, token) {
    var cancelled = false;
    var origin = null;
    var previousAnchor = group.style.overflowAnchor;

    group.style.overflowAnchor = 'none';

    function onWheel() { cancelled = true; }
    function onTouchMove(event) {
      var touch = event.touches && event.touches[0];
      if (!touch) return;
      if (!origin) origin = { x: touch.clientX, y: touch.clientY };
      if (Math.abs(touch.clientY - origin.y) > 12 || Math.abs(touch.clientX - origin.x) > 12) {
        cancelled = true;
      }
    }

    window.addEventListener('wheel', onWheel, { passive: true, capture: true });
    window.addEventListener('touchmove', onTouchMove, { passive: true, capture: true });

    var start = performance.now();

    function cleanup() {
      window.removeEventListener('wheel', onWheel, { capture: true });
      window.removeEventListener('touchmove', onTouchMove, { capture: true });
      group.style.overflowAnchor = previousAnchor;
    }

    function frame(now) {
      if (cancelled || token !== revealToken || !trigger.classList.contains('accordion-is-open')) {
        cleanup();
        return;
      }

      // Instant steps. The panel height is changing every frame, so each step
      // only covers what is newly past the edge.
      revealPanel(trigger, body);

      if (now - start < CHASE_MS) {
        window.requestAnimationFrame(frame);
      } else {
        cleanup();
        watchLateMedia(trigger, body, token);
      }
    }

    window.requestAnimationFrame(frame);
  }

  function watchLateMedia(trigger, body, token) {
    var media = body.querySelectorAll('img, video');
    if (!media.length) return;
    function again() {
      if (token !== revealToken || !trigger.classList.contains('accordion-is-open')) return;
      revealPanel(trigger, body);
    }
    media.forEach(function (node) {
      if (node.tagName === 'IMG' && node.complete) return;
      if (node.tagName === 'VIDEO' && node.readyState >= 2) return;
      node.addEventListener('load', again, { once: true });
      node.addEventListener('loadeddata', again, { once: true });
    });
  }
})();
